/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ItineratorChallenge,
  ItineratorChallengeList,
  ItineratorError,
  ItineratorGetChallengesParams,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Challenges<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Challenge
   * @name GetChallenges
   * @summary List all challenges
   * @request GET:/challenges
   * @secure
   */
  getChallenges = (query?: ItineratorGetChallengesParams, params: RequestParams = {}) =>
    this.request<ItineratorChallengeList, ItineratorError>({
      path: `/challenges`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Challenge
   * @name GetChallengeBySlug
   * @summary Find a challenge by slug
   * @request GET:/challenges/{slug}
   * @secure
   */
  getChallengeBySlug = (slug: string | number, params: RequestParams = {}) =>
    this.request<ItineratorChallenge, ItineratorError>({
      path: `/challenges/${slug}`,
      method: "GET",
      secure: true,
      ...params,
    });
}
